import { APIComponentAttributes, ArdoqId } from '@ardoq/api-types';
import { componentInterface } from '@ardoq/component-interface';
import { toIds } from '@ardoq/core';
import { getTargetData } from './getTargetData';
import { ComponentsData } from '../types';
import { composeComponentsIds } from './composeComponentsIds';

export const getSourceData = (
  selectedComponentId: ArdoqId | null,
  workspaceId: ArdoqId | null,
  childrenByParent: Map<ArdoqId, APIComponentAttributes[]>,
  limit = Infinity
): ComponentsData => {
  if (!selectedComponentId) {
    return getTargetData(workspaceId, limit);
  }

  const children = toIds(childrenByParent.get(selectedComponentId) ?? []);
  const parentId = componentInterface.getParentId(selectedComponentId);

  if (workspaceId && children.length === 0) {
    if (!parentId) {
      return getTargetData(workspaceId, limit);
    }

    return getSourceData(parentId, workspaceId, childrenByParent, limit);
  }

  const hierarchy =
    componentInterface.getComponentHierarchy(selectedComponentId);

  if (!hierarchy[selectedComponentId]) {
    return { componentIds: [], workspaceName: null, allComponentsCount: 0 };
  }

  const allComponentsCount = Object.keys(hierarchy).length;
  const isLimitingComponents = allComponentsCount > limit;

  const componentIds = composeComponentsIds({
    hierarchy,
    children: [selectedComponentId],
    limit: isLimitingComponents ? limit : Infinity,
  });

  return { componentIds, workspaceName: null, allComponentsCount };
};
